import apiClient from './apiMainClient'

/**
 * Obtém estatísticas gerais.
 *
 * @returns {Promise<Object[]>} - Lista de telemedicinas.
 */
export const getGeneralStatistics = async () => {
  try {
    const response = await apiClient.get('/dashboard/general-statistics')
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

/**
 * Obtém consultas por período.
 *
 * @param {string} period - Período para filtrar: '12months' | 'currentMonth' | 'last30days' | 'lastMonth' | 'twoMonthsAgo'
 * @returns {Promise<Object[]>} - Lista de consultas por período.
 */
export const getConsultationsByPeriod = async (period = '12months', specialtyId = null) => {
  try {
    const response = await apiClient.get(`/dashboard/consultations-by-period?period=${period}${specialtyId ? `&specialtyId=${specialtyId}` : ''}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

/**
 * Obtém consultas próximas.
 *
 * @param {number} limit - Número de consultas a retornar.
 * @returns {Promise<Object[]>} - Lista de consultas próximas.
 */
export const getConsultationsNext = async (limit = 100) => {
  try {
    const response = await apiClient.get(`/dashboard/consultations-next?limit=${limit}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

/**
 * Obtém consultas próximas do paciente logado.
 */
export const getConsultationsNextPatient = async (limit = 100) => {
  try {
    const response = await apiClient.get(`/dashboard/consultations-next/patient?limit=${limit}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

/**
 * Obtém documentos de prontuário do paciente logado.
 */
export const getHealthRecordDocumentsPatient = async (limit = 100) => {
  try {
    const response = await apiClient.get(`/dashboard/health-record-documents/patient?limit=${limit}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

/**
 * Obtém aniversariantes do dia.
 *
 * @param {string} type - Tipo de aniversariante: 'all' | 'healthProfessional' | 'patient'
 * @returns {Promise<Object[]>} - Lista de aniversariantes do dia.
 */
export const getBirthdayPeopleOfDay = async (type = 'all') => {
  try {
    const response = await apiClient.get(`/dashboard/birthday-people-of-day?type=${type}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}
